import { InformationCircleIcon } from '@heroicons/react/24/outline'
import 'react-loading-skeleton/dist/skeleton.css'
import { isSet } from '../../../../../helpers'
import { StyleSheet, View } from '../../compiler'
import { colors, typoStyles } from '../../constants'
import BeamGraph from '../graphs/BeamGraph'
import MarkdownText from '../MarkdownText'

import Skeleton from 'react-loading-skeleton'

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 24
  },
  topContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 24,
    paddingHorizontal: 24,
    paddingBottom: 16,
    borderWidth: 1,
    borderColor: colors.lightGrey,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  },
  bottomContainer: {
    padding: 24,
    backgroundColor: colors.lightPaleGrey,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: colors.lightGrey
  },
  endpoleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8
  },
  bigBeamGraphContainer: {
    padding: 24,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: colors.lightGrey
  }
})

const DimensionCard = ({
  title,
  description,
  endPoleLeftTitle,
  endPoleRightTitle,
  talentScore,
  insightDescription,
  expertInputValues,
  maxGreen,
  maxYellow,
  minGreen,
  minYellow,
  onClickDimensionTitle,
  containerStyle,
  isLoading,
  hasCompletedOnboarding = true
}) => {
  return (
    <View style={[styles.container, containerStyle]}>
      <View
        style={[
          styles.topContainer,
          !insightDescription && { borderRadius: 8 },
          !insightDescription &&
            description && {
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0
            }
        ]}
      >
        <View>
          <button
            disabled={!isSet(onClickDimensionTitle) || !hasCompletedOnboarding}
            onClick={onClickDimensionTitle}
            className='flex flex-row items-center gap-x-1'
          >
            <MarkdownText
              style={[
                typoStyles.H4Black,
                { textTransform: 'uppercase' },
                { display: 'block' }
              ]}
            >
              {isLoading ? <Skeleton width={100} /> : title}
            </MarkdownText>
            {onClickDimensionTitle &&
              (isLoading ? (
                <Skeleton width={24} height={24} />
              ) : (
                <InformationCircleIcon
                  className={`h-6 w-6 ${!hasCompletedOnboarding ? 'text-lightGrey opacity-50' : 'text-darkBlack'}`}
                />
              ))}
          </button>

          {description && (
            <MarkdownText
              style={[
                typoStyles.T1Black,
                { color: colors.rockGrey, marginTop: 2, maxWidth: '85%' },
                { display: 'block' }
              ]}
            >
              {isLoading ? <Skeleton count={3} /> : description}
            </MarkdownText>
          )}
        </View>
        {!description && (
          <View style={{ width: '39.6%' }}>
            {isLoading ? (
              <Skeleton />
            ) : (
              <BeamGraph
                userDimensionValue={talentScore}
                expertInputValues={expertInputValues}
                maxGreen={maxGreen}
                maxYellow={maxYellow}
                minGreen={minGreen}
                minYellow={minYellow}
              />
            )}
            <View style={styles.endpoleContainer}>
              <MarkdownText style={typoStyles.SmallBlack}>
                {isLoading ? <Skeleton width={100} /> : endPoleLeftTitle}
              </MarkdownText>
              <MarkdownText style={typoStyles.SmallBlack}>
                {isLoading ? <Skeleton width={100} /> : endPoleRightTitle}
              </MarkdownText>
            </View>
          </View>
        )}
      </View>
      {description && (
        <View
          style={[
            styles.bigBeamGraphContainer,
            !insightDescription && {
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8
            }
          ]}
        >
          {isLoading ? (
            <Skeleton />
          ) : (
            <BeamGraph
              userDimensionValue={talentScore}
              expertInputValues={expertInputValues}
              maxGreen={maxGreen}
              maxYellow={maxYellow}
              minGreen={minGreen}
              minYellow={minYellow}
            />
          )}
          <View style={styles.endpoleContainer}>
            <MarkdownText style={typoStyles.SmallBlack}>
              {isLoading ? <Skeleton width={100} /> : endPoleLeftTitle}
            </MarkdownText>
            <MarkdownText style={typoStyles.SmallBlack}>
              {isLoading ? <Skeleton width={100} /> : endPoleRightTitle}
            </MarkdownText>
          </View>
        </View>
      )}
      {insightDescription && (
        <View style={styles.bottomContainer}>
          <MarkdownText style={[typoStyles.T1Black, { width: '75%' }]}>
            {isLoading ? <Skeleton count={3} /> : insightDescription}
          </MarkdownText>
        </View>
      )}
    </View>
  )
}

export default DimensionCard
